import * as React from "react";
import { Col, Row } from "reactstrap";

import {
  ComboBox,
  TextField,
  Dropdown,
  ChoiceGroup,
  MessageBar,
  MessageBarType,
  Spinner,
  SpinnerSize,
  IDropdownOption,
  IChoiceGroupOption,
  Stack,
  Callout,
  FocusTrapZone,
  Calendar,
  DirectionalHint,
  PrimaryButton
} from "@fluentui/react";


import { constGenericDropdownPlaceholder, constVarianteKeyAbmeldung, constVarianteKeyAenderung, constVarianteKeyErstanforderung, DateStrings } from "../../../../common/CommonConstants";
import { AntragstellerAnschlussnehmerOPSConsts, AntragstellerAnschlussnehmerStyle, apiEndpointSubmit, constLageMaxWidthChar, FormFieldsSN, LeistungsanderungOPSConsts, VariantenSN } from "./StromnetzeRequestConstants";

import * as commonCode from "../../../../common/components/request/RequestCommonCode";

import { IStromnetzeRequestProps } from "./IStromnetzeRequestProps";
import { IStromnetzeRequestState } from "./IStromnetzeRequestState";

import "bootstrap/dist/css/bootstrap.css";
import "../../../../common/components/request/fabric.css";                    // radio buttons horizontal layout
import { ICompany, IGenericOption } from "../../../../common/CommonTypes";
import { StromNetzErrors, StromNetzRecord } from "./StromnetzeRequestTypes";
import { BaseDataFragment } from "../../../../common/components/request/BaseDataFragment";
import { dropdownStyles, stylesChoiceGroupSupressDisabledLookFN, stylesDropdownSupressDisabledLookFN, stylesTextFieldSupressDisabledLookFN } from "../../../../common/CommonStyles";


class StromnetzeRequest extends React.Component<IStromnetzeRequestProps, IStromnetzeRequestState> {

  private buttonContainerRef = React.createRef<HTMLDivElement>();
  private VariantenOPS: IGenericOption[];
  private VoltagesOPS: IGenericOption[];
  
  constructor(props: any) {
    super(props);

    this.VariantenOPS = VariantenSN.map(v => ({ key: v.Key, text: v.RadioButtonLabel }));
    this.VoltagesOPS = this.props.voltages.map( v => ({ key: v.Key, text: v.Key}));

    this.state = {
      AntragstellerFirmaOPS: this.props.companies.map(c => ({key: c.Name, text: c.Name})),  // !SK! Changed to .Name from .Key
      companyAllowFreeform: true,
      // companyIsISG: req ? company?.IstISG : false,
      companyIsISG: this.props.currentRecord ? 
        this.props.companies.filter(c => c.Name === this.props.currentRecord.AntragstellerFirma)[0]?.IstISG : false,   // !SK! Changed to .Name from .Key
      showCalendar: false,
      showSpinner: false,
      // formReadOnly: req ? true : false,
      formReadOnly: this.props.currentRecord ? true : false,
      // formReadOnly: false,
      submitMessage: "",
      minDate: new Date,

      // LageBeschreibungIsMultiline: req ? req[fn.constSNLLageBeschreibungIN]?.length > constLageMaxWidthChar : false, 
      LageBeschreibungIsMultiline: this.props.currentRecord ? this.props.currentRecord.LageBeschreibung?.length > constLageMaxWidthChar : false, 
      
      currentRecord: this.props.currentRecord ? this.props.currentRecord : new StromNetzRecord,

      currentRecordErrors: new StromNetzErrors
      
    } as IStromnetzeRequestState;
  }

  public async componentDidMount() {
    console.log('StromNetze componentDidMount fired');

  }

  onChangeChoiceGroup = async (ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, option?: IChoiceGroupOption | undefined) => {
    const state: IStromnetzeRequestState = { ...this.state };

    if (option?.key) {
      state.currentRecord.AntragsVariante = option.key;
      
      // clear variant fields, which are not the same for all variants
      state.currentRecord.Leistungsbedarf = "";                         // * Erstanforderung
      state.currentRecord.LageBeschreibung = "";                            // * Erstanforderung
      state.currentRecord.Leistungsaenderung = "";                       // * Änderung
      state.currentRecord.Leistung = "";                                // * Änderung
      state.currentRecord.AbzumeldendeLeistung = "";                    // * Abmeldung

      state.currentRecordErrors.AntragsVariante = "";
      
      // clear error messages for variant fields, which are not the same for all variants
      state.currentRecordErrors.Leistungsbedarf = "";                   // * Erstanforderung
      state.currentRecordErrors.LageBeschreibung = "";                      // * Erstanforderung
      state.currentRecordErrors.Leistungsaenderung = "";                 // * Änderung
      state.currentRecordErrors.Leistung = "";                          // * Änderung
      state.currentRecordErrors.AbzumeldendeLeistung = "";              // * Abmeldung
    }
    else {
      console.log("onChangeChoiceGroup: missing option.key");
    }

    this.setState(state);
  };


  onChangeLageBeschreibung = async (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
                                newValue?: string | undefined) => {
    // debugger;                              
    // await this.setState({
    //   LageBeschreibungIsMultiline : event.currentTarget.value.length > constLageMaxWidthChar,
    //   currentRecord: {... this.state.currentRecord, LageBeschreibung: event.currentTarget.value}    // !!! This broke FormIsSN(), see below why
    // });
    // debugger;

    // because we are assigning an in-place untyped Object to currentRecord, so its constructor becomes "Object"

    const state: IStromnetzeRequestState = { ...this.state };
    state.LageBeschreibungIsMultiline = event.currentTarget.value.length > constLageMaxWidthChar;
    state.currentRecord.LageBeschreibung = event.currentTarget.value;
    state.currentRecordErrors.LageBeschreibung = "";
                         
    this.setState(state);
  };

  onChangeAntragstellerAnschlussnehmer = async (event: React.FormEvent<HTMLDivElement>, 
                                                option?: IDropdownOption<any> | undefined, 
                                                index?: number | undefined) => {

    const state: IStromnetzeRequestState = { ...this.state };

    state.currentRecord.AntragstellerIsAnschlussnehmer = (option?.text === "ja");
    state.currentRecordErrors.AntragstellerIsAnschlussnehmer = "";

    this.setState(state);
  };


  render() {
    return (
      <React.Fragment>
        {BaseDataFragment.bind(this)()}

        <Row>
          <Col md="12">
            <Dropdown
              id="AntragstellerIsAnschlussnehmer"
              label={this.props.formFields.find(f => f.Id === "AntragstellerIsAnschlussnehmer").Label}
              // label="Antragsteller ist auch verantwortlicher Anschlussnehmer"
              placeholder={constGenericDropdownPlaceholder}
              options={AntragstellerAnschlussnehmerOPSConsts}
              selectedKey={this.state.currentRecord.AntragstellerIsAnschlussnehmer === true ? 'ja' 
                         : this.state.currentRecord.AntragstellerIsAnschlussnehmer === false ? 'nein'
                         : undefined}
              styles={{...AntragstellerAnschlussnehmerStyle, ...stylesDropdownSupressDisabledLookFN(this.state.formReadOnly)}}
              // styles={stylesDropdownSupressDisabledLookFN(this.state.formReadOnly)}                  
              required
              disabled={this.state.formReadOnly}
              onChange={this.onChangeAntragstellerAnschlussnehmer}
              errorMessage={this.state.currentRecordErrors.AntragstellerIsAnschlussnehmer}
              onBlur={commonCode.ValidateOnBlur.bind(this)}
            />
          </Col>
        </Row>

        {/* {this.state.AntragstellerAnschlussnehmerRequired === true ? ( */}
        {this.state.currentRecord.AntragstellerIsAnschlussnehmer === false ? (
          <>
            <Row>
              <Col
                md="12"
                style={{ textAlign: "left", marginTop: "10px" }}
              >
                <h5>Verantwortlicher Anschlussnehmer</h5>
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <TextField
                  id="AnschlussnehmerVorname"
                  label={this.props.formFields.find(f => f.Id === "AnschlussnehmerVorname").Label}
                  // label="Anschlussnehmer Vorname"
                  value={this.state.currentRecord.AnschlussnehmerVorname}
                  styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                  maxLength={50}
                  required
                  disabled={this.state.formReadOnly}
                  autoComplete={this.props.autoCompleteMode}
                  onChange={commonCode.onChangeTextBox_NameFld.bind(this)}
                  errorMessage={this.state.currentRecordErrors.AnschlussnehmerVorname}
                  onBlur={commonCode.ValidateOnBlur.bind(this)}
                />
              </Col>
              <Col md="3">
                <TextField
                  id="AnschlussnehmerNachname"
                  label={this.props.formFields.find(f => f.Id === "AnschlussnehmerNachname").Label}
                  // label="Anschlussnehmer Nachname"
                  value={this.state.currentRecord.AnschlussnehmerNachname}
                  styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                  maxLength={50}
                  autoComplete={this.props.autoCompleteMode}
                  required
                  disabled={this.state.formReadOnly}
                  onChange={commonCode.onChangeTextBox_NameFld.bind(this)}
                  errorMessage={this.state.currentRecordErrors.AnschlussnehmerNachname}
                  onBlur={commonCode.ValidateOnBlur.bind(this)}
                />
              </Col>
              <Col md="4">
                <TextField
                  id="AnschlussnehmerEmail"
                  label={this.props.formFields.find(f => f.Id === "AnschlussnehmerEmail").Label}
                  // label="Anschlussnehmer Email"
                  value={this.state.currentRecord.AnschlussnehmerEmail}
                  styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                  maxLength={50}
                  required
                  autoComplete={this.props.autoCompleteMode}
                  disabled={this.state.formReadOnly}
                  onChange={commonCode.onChangeTextBox_EmailFld.bind(this)}
                  errorMessage={this.state.currentRecordErrors.AnschlussnehmerEmail}
                  onBlur={commonCode.ValidateOnBlur.bind(this)}
                />
              </Col>
              <Col md="2">
                <TextField
                  id="AnschlussnehmerTelefon"
                  label={this.props.formFields.find(f => f.Id === "AnschlussnehmerTelefon").Label}
                  // label="Anschlussnehmer Telefon"
                  value={this.state.currentRecord.AnschlussnehmerTelefon}
                  styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                  autoComplete={this.props.autoCompleteMode}
                  required
                  disabled={this.state.formReadOnly}
                  onChange={commonCode.onChangeTextBox_PhoneFld.bind(this)}
                  errorMessage={this.state.currentRecordErrors.AnschlussnehmerTelefon}
                  onBlur={commonCode.ValidateOnBlur.bind(this)}
                />
              </Col>
            </Row>
          </>
        ) : null}

        <hr />
		
        <Row>
          <Col md="6" sm="12" style={{ textAlign: "left" }}>
            <ChoiceGroup
              id="AntragsVariante"
              className="inlineflex"
              options={this.VariantenOPS}
              selectedKey={this.state.currentRecord.AntragsVariante}
              styles={stylesChoiceGroupSupressDisabledLookFN(this.state.formReadOnly)}
              required
              disabled={this.state.formReadOnly}
              onChange={this.onChangeChoiceGroup}
            />
          </Col>
          <Col md="6" sm="12">
            {this.state.currentRecordErrors.AntragsVariante.length > 0 ? (
              <MessageBar
                messageBarType={MessageBarType.error}
                isMultiline={false}
              >
                {this.state.currentRecordErrors.AntragsVariante}
              </MessageBar>
            ) : null}
          </Col>
        </Row>
        <hr />

        {this.state.currentRecord.AntragsVariante !== "" ? 
          <>
            <Row>
              <Col md="12" style={{ textAlign: "left" }}>
                <h5>{VariantenSN.filter(el => el.Key === this.state.currentRecord.AntragsVariante)[0]?.AbschnittTitel}</h5>
              </Col>
            </Row>
            <Row>
              <Col md="2">
                <Dropdown
                  id="Spannungsebene"
                  label={this.props.formFields.find(f => f.Id === "Spannungsebene").Label}
                  // label="Spannungsebene"
                  placeholder={constGenericDropdownPlaceholder}
                  options={this.VoltagesOPS}
                  selectedKey={this.state.currentRecord.Spannungsebene}
                  styles={stylesDropdownSupressDisabledLookFN(this.state.formReadOnly)}                  
                  required
                  disabled={this.state.formReadOnly}
                  onChange={commonCode.onChangeDropdown.bind(this)}
                  errorMessage={this.state.currentRecordErrors.Spannungsebene}
                  onBlur={commonCode.ValidateOnBlur.bind(this)}
                />
              </Col>

            {this.state.currentRecord.AntragsVariante === constVarianteKeyErstanforderung ? (
              <>
                <Col md="2">
                  <TextField
                    id="Leistungsbedarf"
                    label={this.props.formFields.find(f => f.Id === "Leistungsbedarf").Label}
                    // label="Leistungsbedarf"
                    suffix="kW"
                    value={this.state.currentRecord.Leistungsbedarf}
                    styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                    autoComplete={this.props.autoCompleteMode}
                    required
                    disabled={this.state.formReadOnly}
                    onChange={commonCode.onChangeTextBox_NumberFld.bind(this)}
                    errorMessage={this.state.currentRecordErrors.Leistungsbedarf}
                    onBlur={commonCode.ValidateOnBlur.bind(this)}
                  />
                </Col>
                <Col md="8">
                  <TextField
                    id="LageBeschreibung"
                    label={this.props.formFields.find(f => f.Id === "LageBeschreibung").Label}
                    // label="Beschreibung der gewünschten Lage des Übergabepunktes"
                    maxLength={1000}
                    placeholder="Max. 1000"
                    multiline={this.state.LageBeschreibungIsMultiline}
                    autoAdjustHeight={this.state.LageBeschreibungIsMultiline}
                    autoComplete={this.props.autoCompleteMode}
                    required
                    disabled={this.state.formReadOnly}
                    value={this.state.currentRecord.LageBeschreibung}
                    styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                    onChange={this.onChangeLageBeschreibung}
                    errorMessage={this.state.currentRecordErrors.LageBeschreibung}
                    onBlur={commonCode.ValidateOnBlur.bind(this)}
                  />
                </Col>
              </>
            ) : null}
            {/* ********************** */}
            {this.state.currentRecord.AntragsVariante === constVarianteKeyAenderung ? (
              <>
                <Col md="2">
                  <Dropdown
                    id="Leistungsaenderung"
                    label={this.props.formFields.find(f => f.Id === "Leistungsaenderung").Label}
                    // label="Leistungsänderung"
                    placeholder={constGenericDropdownPlaceholder}
                    options={LeistungsanderungOPSConsts}
                    styles={stylesDropdownSupressDisabledLookFN(this.state.formReadOnly)}                  
                    selectedKey={this.state.currentRecord.Leistungsaenderung}
                    required
                    disabled={this.state.formReadOnly}
                    onChange={commonCode.onChangeDropdown.bind(this)}                      
                    errorMessage={this.state.currentRecordErrors.Leistungsaenderung}
                    onBlur={commonCode.ValidateOnBlur.bind(this)}
                  />
                </Col>
                <Col md="2">
                  <TextField
                    id="Leistung"
                    label={this.props.formFields.find(f => f.Id === "Leistung").Label}
                    // label="Leistung"
                    suffix="kW"
                    value={this.state.currentRecord.Leistung}
                    styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                    autoComplete={this.props.autoCompleteMode}
                    required
                    disabled={this.state.formReadOnly}
                    onChange={commonCode.onChangeTextBox_NumberFld.bind(this)}
                    errorMessage={this.state.currentRecordErrors.Leistung}
                    onBlur={commonCode.ValidateOnBlur.bind(this)}
                  />
                </Col>
              </>
            ) : null}
            {/* ********************** */}
            {this.state.currentRecord.AntragsVariante === constVarianteKeyAbmeldung ? (
              <>
                <Col md="2">
                  <TextField
                    id="AbzumeldendeLeistung"
                    label={this.props.formFields.find(f => f.Id === "AbzumeldendeLeistung").Label}
                    // label="Abzumeldende Leistung"
                    suffix="kW"
                    value={this.state.currentRecord.AbzumeldendeLeistung}
                    styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                    autoComplete={this.props.autoCompleteMode}
                    required
                    disabled={this.state.formReadOnly}
                    onChange={commonCode.onChangeTextBox_NumberFld.bind(this)}
                    errorMessage={this.state.currentRecordErrors.AbzumeldendeLeistung}
                    onBlur={commonCode.ValidateOnBlur.bind(this)}
                  />
                </Col>
              </>
            ) : null}
            {/* ********************** */}
            </Row>
          </>
        : null}

        <Row>
          <Col md="12">
            <TextField
              id="BemerkungAntragsteller"
              label={this.props.formFields.find(f => f.Id === "BemerkungAntragsteller").Label}
              // label="Bemerkung Antragsteller"
              value={this.state.currentRecord.BemerkungAntragsteller}
              styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
              multiline
              autoAdjustHeight
              maxLength={2048}
              placeholder=" Max. 2048"
              autoComplete={this.props.autoCompleteMode}
              disabled={this.state.formReadOnly}
              onChange={commonCode.onChangeTextBoxBasic.bind(this)}
              />
          </Col>
        </Row>
        <Row>
        <Col md="4">
            <div ref={this.buttonContainerRef}>
              <TextField
                id="BedarfsterminGeschaetzt"
                label={this.props.formFields.find(f => f.Id === "BedarfsterminGeschaetzt").Label}
                // label="Bedarfstermin voraussichtlich ab"
                autoComplete={this.props.autoCompleteMode}
                value={this.state.currentRecord.BedarfsterminGeschaetzt}
                styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                disabled={this.state.formReadOnly}
                onClick={commonCode.toggleShowCalendar.bind(this)}
                required
                errorMessage={this.state.currentRecordErrors.BedarfsterminGeschaetzt}
                onBlur={commonCode.ValidateOnBlur.bind(this)}
              />
            </div>
            {this.state.showCalendar && (
              <Callout
                isBeakVisible={false}
                gapSpace={0}
                doNotLayer={false}
                target={this.buttonContainerRef}
                directionalHint={DirectionalHint.bottomLeftEdge}
                onDismiss={commonCode.hideCalendar.bind(this)}
                // goToToday={false}
                setInitialFocus
              >
                <FocusTrapZone isClickableOutsideFocusTrap>
                  <Calendar
                    onSelectDate={(date: Date, selectedDateRangeArray?: Date[] | undefined) => { 
                      commonCode.onSelectMonthCalendarNested.bind(this)(date, "BedarfsterminGeschaetzt");
                    }}
                    onDismiss={commonCode.hideCalendar.bind(this)}
                    isMonthPickerVisible
                    highlightCurrentMonth
                    isDayPickerVisible={false}
                    strings={DateStrings}
                    minDate={this.state.minDate}
                  />
                </FocusTrapZone>
              </Callout>
            )}
          </Col>
          {this.state.companyIsISG === true ? (
            <Col md="3">
              <TextField
                id="KontoEnergieverrechnung"
                label={this.props.formFields.find(f => f.Id === "KontoEnergieverrechnung").Label}
                // label="Konto für Energieverrechnung"
                value={this.state.currentRecord.KontoEnergieverrechnung}
                styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                maxLength={10}
                placeholder="Max. 10"
                autoComplete={this.props.autoCompleteMode}
                disabled={this.state.formReadOnly}
                // required={this.state.KontoEnergieverrechnungRequired}
                required
                onChange={commonCode.onChangeTextBoxBasic.bind(this)}
                errorMessage={this.state.currentRecordErrors.KontoEnergieverrechnung}
                onBlur={commonCode.ValidateOnBlur.bind(this)}
              />
            </Col>
          ) : null}
        </Row>
        <hr />

        <Stack
          horizontal
          horizontalAlign="space-between"
        >
          <Stack.Item align="stretch">
            {`Antragsdatum: ${this.state.currentRecord.Antragsdatum.toLocaleString("de-de", { year: 'numeric', month: 'long', day: 'numeric' })}`}
          </Stack.Item>

          {!this.state.formReadOnly ? 
            <Stack.Item align="stretch">                    
              <Stack
                verticalAlign="center"
                verticalFill
              >   
                <Stack.Item
                  hidden={!this.state.showSpinner}
                  align="end"
                  style={{width: 120}}
                >  
                  <Spinner
                    size={SpinnerSize.medium}
                    label="Bitte warten..."
                  />
                </Stack.Item>
                <Stack.Item
                  hidden={this.state.showSpinner}
                  align="end"
                  style={{width: 120}}
                > 
                  <PrimaryButton
                    text="Abschließen"
                    disabled={this.state.formReadOnly}
                    // onClick={async () => { await commonCode.onSubmitNested.bind(this)(apiEndpointSubmit, this.FormValidateSN, false); } }
                    // onClick={async () => { await commonCode.onSubmitNested.bind(this)(apiEndpointSubmit, FormFieldsSN, false); } }
                    onClick={async () => { await commonCode.onSubmitNested.bind(this)(apiEndpointSubmit, this.props.noFormDisable); } }
                  />
                </Stack.Item>
                <Stack.Item
                  hidden={this.state.showSpinner}
                  align="center"
                > 
                  {this.state.submitMessage}
                </Stack.Item>
              </Stack>
            </Stack.Item>
          :
            <Stack.Item align="stretch">
              {this.state.submitMessage}
            </Stack.Item>             
          }
        </Stack>
      </React.Fragment>
    );
  }
}

export default StromnetzeRequest;
